import { createCustomToggle, customSearch, headerElementsReorder } from './helpers';

$(document).ready(function () {
  $('.generalmessage').prependTo('header');
  createCustomToggle();
  customSearch();
  headerElementsReorder();
});
